import { IWidgetConfigItem } from '@sitegen/common/types';

import { WIDGET_CONFIG, WIDGET_NAME } from '@sitegen/common/constants';

const WIDGET_ANALYTICS_INFO = {
    siteSection: 'friends-referral',
    siteName: '',
    homePage: {
        name: 'main',
        subSection: ''
    },
    inviteePage: {
        name: 'you are participating',
        subSection: ''
    },
    invitationPage: {
        name: 'welcome to the program',
        subSection: ''
    },
    referralPage: {
        name: 'dashboard',
        subSection: ''
    },
    errorPage: {
        name: 'error occurred',
        subSection: 'error'
    },
    apiErrorPage: {
        name: 'error occurred',
        subSection: 'api error'
    },
};

export class Analytics {
    public static Constants: typeof WIDGET_ANALYTICS_INFO = WIDGET_ANALYTICS_INFO;

    /** Add extra widget-specific values */
    public static configure(widget: WIDGET_NAME): void {
        const config: IWidgetConfigItem = WIDGET_CONFIG[widget];

        Analytics.Constants.siteSection = config.widgetFlowType;
        Analytics.Constants.siteName = config.widgetAnalytics;
    }
}
